/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonGridRepositoryResponse } from "../types/PersonGridRepositoryResponse.ts";

export const personGridRepositoryResponseSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  cpf: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  isStudent: z.optional(z.boolean()),
  monitorStaff: z.optional(z.boolean()),
  isMonitor: z.optional(z.boolean()),
  isExamItemCreator: z.optional(z.boolean()),
  isExamItemApprover: z.optional(z.boolean()),
  monographStaff: z.optional(z.boolean()),
  isMonographCoordinator: z.optional(z.boolean()),
  isMonographAdvisor: z.optional(z.boolean()),
  isMonographOperational: z.optional(z.boolean()),
  isEmployee: z.optional(z.boolean()),
  isTeachingStaff: z.optional(z.boolean()),
  isSeller: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
  isPCD: z.optional(z.boolean()),
}) as unknown as ToZod<PersonGridRepositoryResponse>;
